import { prop } from "vue-class-component";

export class FileViewHandlerProps {
  category: string = prop({ required: true });
  entity: string = prop({ required: true });
  id: string = prop({ required: true });
  subCategory: string = prop({ required: true });
}